import { render, staticRenderFns } from "./TestimonialCard.vue?vue&type=template&id=d78110d4&scoped=true"
import script from "./TestimonialCard.vue?vue&type=script&lang=js"
export * from "./TestimonialCard.vue?vue&type=script&lang=js"
import style0 from "./TestimonialCard.vue?vue&type=style&index=0&id=d78110d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d78110d4",
  null
  
)

export default component.exports